
import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { IOffcanvasPage } from "./canvas.pages"



const STORE_KEY = "OFFCANVAS_STORE"

export const useCanvasStore = defineStore(STORE_KEY, () => {
    const canvasStack = ref<IOffcanvasPage[]>([])
    const topItemInStack = computed(() => canvasStack.value[canvasStack.value.length - 1] ?? null)

    const push = (page: IOffcanvasPage) => {
        canvasStack.value.push(page)
    }
    const pop = () => {
        canvasStack.value.pop()
    }
    const replace = (page: IOffcanvasPage) => {
        if (!canvasStack.value.length) { return }
        canvasStack.value[canvasStack.value.length - 1] = page
    }
    const clearStack = () => {
        canvasStack.value = []
    }

    return { push, pop, clearStack, topItemInStack, canvasStack, replace }
})